import React from "react"
import { Link } from "react-router-dom"
import "../../assets/css/common.css"
import { t } from '../../components/i18n/i18n'
import { usePageLocale } from '../../components/i18n/usePageLocale'
import back from "../../assets/images/elements/aboutHeader.jpg";
import articlePdf from "../../resources/6-onthe-priesthood.pdf"
import article_img from "../../assets/images/articles/6_full.jpeg"
import ArticleLike from '../../components/ArticleLike'

export const Article6OnThePriesthood = () => {
    const ready = usePageLocale('article6');
    if (!ready) return <div style={{ padding: '60px', textAlign: 'center', color: '#999' }}>•••</div>;
    return (

        <section className='text_container_light'>
            <div className='container_100'>
                {/* Верхній блок з заголовком (як у About) */}
                <div className='backImg15'>
                    <img src={back} alt='' />
                    <div className='text_container_dark_15'>
                        <div className='h1_15'>{t("resourceArticle6Title")}</div>
                    </div>
                </div>

                <br />

                <div className='container boxItems'>
                    {/* Кнопка повернення */}
                    <Link to='/resources' style={{textDecoration: 'none', color: '#777'}}>
                        {t("resourceBackToList")}
                    </Link>
                    <br /><br />

                    <div className='article_grid'>
                        {/* ЛІВА КОЛОНКА: Метадані та Анотація */}
                        <div>
                            <h2 className='menuColor'>{t("resourceArticle6Title")}</h2>

                            <p>{t("resourceArticle6Author")}</p>

                            <div style={{ marginTop: '10px' }}>
                                <a
                                    href={articlePdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="pdf-download-link"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: '#b22222',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}
                                >
                                    <span style={{ marginRight: '8px' }}>📄</span>
                                    {t("resourceArticleDownloadOriginal")}
                                </a>
                            </div>

                            <hr />
                            <br/>

                            <img
                                src={article_img}
                                alt="Хто ми один одному"
                                className="article-img"
                            />

                            <h3 className='menuColor'>{t("resourceArticle6AnnotationTitle")}</h3>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6AnnotationP1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6AnnotationP2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6AnnotationP3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6AnnotationP4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6AnnotationP5") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6AnnotationAuthor") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle6Subtitle")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P4") }} /></p>
                            <br/>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P5") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P6") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P7") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P8") }} /></p>
                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P9") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P10") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P11") }} /></p>


                        </div>

                        {/* ПРАВА КОЛОНКА: Основний зміст */}
                        <div>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P12") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P13") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P14") }} /></p>
                            <br />

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P15") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P16") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P17") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P18") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P19") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P20") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P21") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P22") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P23") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P24") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P25") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle6P26") }} /></p>
                            <br/>

                            <hr />
                            <p style={{ fontSize: '13px', color: '#999', marginTop: '10px' }}>
                                {t("resourceArticle6Copyright")}
                            </p>
                            <br/>

                        </div>
                    </div>
                    <ArticleLike articleId='6-zlatousty-on-the-priesthood' />
                </div>
                <br />
            </div>
        </section>
    )
}
